import * as _ from 'lodash';
import { IProfile } from '../profile';
import { IThing } from '../ryve/Thing';
import { IRoleModel } from './Role';
export class ParticipationRequestType {
  static INVITE = 'invite';
  static REQUEST = 'request';
  static CREATOR = 'creator';
  static MANAGED = 'managed';
  static PUBLIC = 'public';
  static PASSIVE = 'passive';
}

export class ParticipationRequestStatus {
  static PENDING = 'pending';
  static ACCEPTED = 'accepted';
  static DECLINED = 'declined';
  static PASSIVE = 'passive';
}

/**
 * Pseudo-Teilnehmer-Id für den gebündelten Einladungsversand ("Alle Einladungen erneuern").
 * Wird als `participantId` an den Invitation-Endpoint geschickt und dort serverseitig
 * als Sammelaktion über alle offenen Einladungen interpretiert.
 */
export const BULK_UPDATE_PARTICIPANT_ID = 'BULK_UPDATE';

export interface IParticipantModel {
  user: string;
  roles: string[];
  type: string;
  status: string;
}

export interface IParticipantResolvedModel extends IParticipantModel {
  userResolved: IThing<IProfile>;
  message: string;
  createdAt?: number;
  modifiedAt?: number;
}

export interface IParticipationModel extends IParticipantModel {
  _id: string;
  parent: string;
  createdBy: string;
  createdAt: number;
  modifiedAt: number;
  message: string;
  lastReadTimestamp?: number;
}

export interface IParticipationResolvedModel extends IParticipationModel {
  permissions: IRoleModel;
  createdByResolved: IThing<IProfile>;
}

/**
 * Offene, noch nicht beantwortete Einladung. Wird für den Tab-Filter, für die Anzahl im
 * Bestätigungs-Dialog und für die Ableitung des Einladungstextes gleichermaßen benutzt.
 */
export const isOpenInvitation = (p: IParticipantResolvedModel) =>
  p.status === ParticipationRequestStatus.PENDING && p.type === ParticipationRequestType.INVITE && !!p?.userResolved?.content?.userId;

/**
 * Einladungstext für Bestandsobjekte ableiten, die noch kein persistiertes `invitationText`
 * haben: der am häufigsten verwendete Text der offenen Einladungen, bei Gleichstand (also
 * auch dann, wenn alle Texte unterschiedlich sind) der zuletzt geänderte. Sobald damit einmal
 * versendet wurde, schreibt das Backend den Text fest und diese Ableitung greift nicht mehr.
 *
 * Liegt in diesem Modul und nicht in der Participants-Komponente, damit auch der
 * Einladungs-Dialog im Flow sie nutzen kann, ohne die gesamte Listen-UI zu importieren.
 */
export const deriveInvitationText = (participants?: IParticipantResolvedModel[]) => {
  const open = (participants || []).filter(isOpenInvitation).filter(p => !!p.message?.trim());
  if (!open.length) return '';
  const newest = (items: IParticipantResolvedModel[]) => Math.max(...items.map(p => p.modifiedAt ?? p.createdAt ?? 0));
  const ranked = Object.values(_.groupBy(open, p => p.message)).sort((a, b) => b.length - a.length || newest(b) - newest(a));
  return ranked[0][0].message;
};
